var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditingDude(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editing_dude_svg__clip0_601_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.103 94.568c1.872.16 5.12.424 7.675.538 1.539.068 2.425-.084 2.936-.288v.162a.526.526 0 01-.503.5c-3.349.19-6.706.194-10.055.011a.378.378 0 01-.307-.567c.076-.124.161-.243.254-.356z",
    fill: "url(#editing_dude_svg__paint0_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.784 95.106c-2.56-.114-5.808-.377-7.675-.537 1.84-2.257 7.675-3.78 7.675-3.78h1.65a6.92 6.92 0 011.286 4.029c-.511.204-1.397.356-2.936.288z",
    fill: "url(#editing_dude_svg__paint1_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.717 88.094l-.156 3.054a.695.695 0 01-.594.656c-.416.061-.84.026-1.239-.103a.827.827 0 01-.556-.635l-.524-2.965 3.069-.007z",
    fill: "url(#editing_dude_svg__paint2_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.133 95.083c.813-.113 1.179-.535 1.333-.985v.012c.12.474-.157.968-.71 1.202a4.67 4.67 0 01-1.968.308 1.956 1.956 0 01-1.476-.682c.611.297 1.469.333 2.821.145z",
    fill: "url(#editing_dude_svg__paint3_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.31 88.076h1.361c2.07-.041 3.371 4.328 3.797 6.021-.154.45-.523.872-1.333.986-1.352.188-2.21.151-2.822-.15-1.12-1.474-1.675-3.63-1.941-4.884a1.717 1.717 0 01.938-1.973z",
    fill: "url(#editing_dude_svg__paint4_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.49 85.242l.755 3.004a.813.813 0 01-.423.924c-.423.216-1.017.445-1.57.379a.679.679 0 01-.557-.454l-1.109-3.16 2.904-.693z",
    fill: "url(#editing_dude_svg__paint5_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.395 86.111c-.941.834-3.997.944-3.997.944-11.009-26.424-15.513-30.174-15.513-30.174 1.589 9.973.256 32.054.256 32.054-1.817.8-4.16 0-4.16 0a170.11 170.11 0 00-5.622-41.793c7.441-.174 11.399-2.714 12.692-3.736 6.195 9.996 16.344 42.705 16.344 42.705z",
    fill: "url(#editing_dude_svg__paint6_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.159 13.017c1.409 7.025.903 19.599.572 25.333-.092 1.612 1.033 3.848 1.941 5.372a.482.482 0 01.051.378.473.473 0 01-.242.294c-1.523.783-6.683 3.21-12.662 3.51a.852.852 0 01-.858-.636c-4.436-16.57-9.594-27.142-9.594-27.142 5.694-9.082 20.792-7.11 20.792-7.11z",
    fill: "url(#editing_dude_svg__paint7_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.135 56.253a.348.348 0 00.302-.537 11.061 11.061 0 00-4.36-3.788.352.352 0 10-.308.635c1.64.8 3.042 2.014 4.07 3.521a.349.349 0 00.296.17z",
    fill: "url(#editing_dude_svg__paint8_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.994 33.178c-.451 3.272-1.789 6.843-4.463 10.64l-1.015-.829c.719-3.338.89-6.77.505-10.163 1.651-.328 3.599.004 4.973.352z",
    fill: "url(#editing_dude_svg__paint9_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.586 21.684l1.57-8.668s10.511 8.033 8.835 20.162c-1.375-.349-3.315-.68-4.973-.358-.482-3.893-1.912-8.117-5.432-11.136z",
    fill: "url(#editing_dude_svg__paint10_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.375 20.125l4.057 8.736c-.656 5.276-3.489 7.558-6.546 8.431a18.548 18.548 0 00-1.363-5.689c3.904-4.03 3.852-11.478 3.852-11.478z",
    fill: "url(#editing_dude_svg__paint11_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.525 31.604a18.55 18.55 0 011.362 5.689c-8.153 3.164-10.309-2.965-10.309-2.965l1.505-.267c3.404.354 5.781-.743 7.442-2.457z",
    fill: "url(#editing_dude_svg__paint12_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.117 9.338l1.959 7.2a1.394 1.394 0 001.873.933c.964-.38 1.906-.81 2.823-1.291a1.887 1.887 0 00.666-2.712l-4.073-6.072-3.248 1.942z",
    fill: "url(#editing_dude_svg__paint13_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.828 3.869c-.017.123 1.635 8.216 1.635 8.216l4.6-1.046-.426-7.903s-5.51-1.338-5.809.733z",
    fill: "url(#editing_dude_svg__paint14_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.606 4.9l.55 4.142a.603.603 0 010 .159c-.047.326-.288 1.43-1.396 1.114-1.013-.286-1.941-.534-2.583-.336a.582.582 0 00-.401.675 25.286 25.286 0 001.059 3.77.585.585 0 00.708.35c.872-.255 2.698-.843 4.055-1.66a.59.59 0 00.284-.523c-.043-1.046-.174-4.224-.062-5.115.096-.836 1.123-1.338 1.57-1.518a.568.568 0 00.319-.319c.207-.523.492-1.716-1.017-2.206a.585.585 0 01-.37-.757c.223-.621.317-1.57-.851-2.093-1.169-.523-2.072.101-2.552.616a.582.582 0 01-.743.087.462.462 0 00-.523.017.572.572 0 01-.813-.246c-.285-.584-.872-1.208-2.027-1.01-2.062.35-2.296 2.638-1.744 3.977.55 1.34 2.757.829 3.868.154.845-.513 1.94.024 2.416.312a.579.579 0 01.253.41z",
    fill: "url(#editing_dude_svg__paint15_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.995 8.978s-.848-2.373.023-2.954c.87-.58 2.161-.28 1.877 1.44-.353 2.144-1.9 1.514-1.9 1.514z",
    fill: "url(#editing_dude_svg__paint16_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.185 35.445c-.41.321-1.816-.349-2.676-.811a.991.991 0 01-.48-1.17c.208-.653.554-1.495.98-1.601.704-.177 3.868 2.262 2.176 3.582z",
    fill: "url(#editing_dude_svg__paint17_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.41 55.27L34.062 17.091l-5.68 15.776L135.702 72.11a5.006 5.006 0 006.044-2.188c1.256-2.154 2.454-5.52 2.526-10.562a4.29 4.29 0 00-2.861-4.092z",
    fill: "url(#editing_dude_svg__paint18_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.834 13.014l14.827 1.821c-.016 2.04-.684 4.681-2.947 7.71L.33 14.377a.744.744 0 01.504-1.362z",
    fill: "url(#editing_dude_svg__paint19_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.056 17.093c.68 9.887-5.68 15.776-5.68 15.776l-15.65-10.322c2.268-3.03 2.93-5.67 2.947-7.711l18.383 2.257z",
    fill: "url(#editing_dude_svg__paint20_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.072 60.107a.317.317 0 00.27-.474.314.314 0 00-.165-.138L37.467 23.2a.317.317 0 00-.418.187.314.314 0 00.209.407l102.71 36.296a.31.31 0 00.104.017z",
    fill: "url(#editing_dude_svg__paint21_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.299 66.293a.316.316 0 00.106-.614L35.694 29.383a.317.317 0 00-.418.187.316.316 0 00.208.408l102.705 36.3a.314.314 0 00.11.015z",
    fill: "url(#editing_dude_svg__paint22_linear_601_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.94 42.84l-4.745-.387-2.054 1.894s.485.673 2.006.286c1.521-.387 3.601-.481 3.601-.481s2.094.947 2.123-.823l-.931-.489z",
    fill: "url(#editing_dude_svg__paint23_linear_601_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint0_linear_601_2",
    x1: 116.856,
    y1: 200.165,
    x2: 112.923,
    y2: 176.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint1_linear_601_2",
    x1: 104.72,
    y1: 92.955,
    x2: 94.104,
    y2: 92.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint2_linear_601_2",
    x1: 103.717,
    y1: 89.967,
    x2: 100.64,
    y2: 89.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint3_linear_601_2",
    x1: 3741.75,
    y1: 3321.16,
    x2: 3754.7,
    y2: 3109.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint4_linear_601_2",
    x1: 5967.99,
    y1: 10837.4,
    x2: 6184.5,
    y2: 10837.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint5_linear_601_2",
    x1: 3691.3,
    y1: 6497.49,
    x2: 3768.95,
    y2: 6497.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint6_linear_601_2",
    x1: 32977.8,
    y1: 59271,
    x2: 21538.8,
    y2: 69819.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint7_linear_601_2",
    x1: 122.839,
    y1: 12.087,
    x2: 65.434,
    y2: 53.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3088F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91B3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint8_linear_601_2",
    x1: 110.887,
    y1: 73.785,
    x2: 109.125,
    y2: 70.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint9_linear_601_2",
    x1: 5949.48,
    y1: 13136.3,
    x2: 5333.06,
    y2: 13405.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint10_linear_601_2",
    x1: 13681.5,
    y1: 21349.5,
    x2: 9027.78,
    y2: 23130.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint11_linear_601_2",
    x1: 9937.31,
    y1: 17332.2,
    x2: 6355.25,
    y2: 18535.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint12_linear_601_2",
    x1: 12512,
    y1: 7841.91,
    x2: 13121.3,
    y2: 7841.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint13_linear_601_2",
    x1: 8443.62,
    y1: 10333.6,
    x2: 8746.96,
    y2: 11331.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint14_linear_601_2",
    x1: -8447.17,
    y1: 24339.1,
    x2: -7992.03,
    y2: 24869.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint15_linear_601_2",
    x1: -13929,
    y1: 38743,
    x2: -14639.8,
    y2: 38642.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint16_linear_601_2",
    x1: -2865.35,
    y1: 8603.93,
    x2: -2986.91,
    y2: 8488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint17_linear_601_2",
    x1: 72.675,
    y1: 33.692,
    x2: 68.984,
    y2: 33.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint18_linear_601_2",
    x1: 121530,
    y1: 40966.7,
    x2: 121893,
    y2: 59224.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint19_linear_601_2",
    x1: 23922.2,
    y1: 11055.6,
    x2: 24986.6,
    y2: 9535.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint20_linear_601_2",
    x1: 33459.6,
    y1: 19394.9,
    x2: 25756.5,
    y2: 28780.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint21_linear_601_2",
    x1: 125506,
    y1: 39118.9,
    x2: 122775,
    y2: 66173.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3088F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint22_linear_601_2",
    x1: 127444,
    y1: 39322.3,
    x2: 124713,
    y2: 66378.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3088F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "editing_dude_svg__paint23_linear_601_2",
    x1: 8572.95,
    y1: 2828.48,
    x2: 8467.94,
    y2: 3141.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "editing_dude_svg__clip0_601_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h144.26v95.624H0z"
  })))));
}
export default SvgEditingDude;